<ng-template #content let-modal>
  <div class="modal-body" style="width:100%;">
    <nav ngbNav #nav="ngbNav" class="nav-tabs">

      <ng-container ngbNavItem *qmAuth="'vivo'">
        <a ngbNavLink>{{'Diary' | translate}}</a>
        <ng-template ngbNavContent>
          <qm-vivo-notification (close)="close()"></qm-vivo-notification>
        </ng-template>
      </ng-container>

      <ng-container ngbNavItem>
        <a ngbNavLink>{{'Whiteboard' | translate}}</a>
        <ng-template ngbNavContent>
          <qm-whiteboard></qm-whiteboard>
        </ng-template>
      </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</ng-template>



<button class="btn btn-primary new-entry-btn" (click)="open(content)" placement="right" container="body" ngbTooltip="{{ 'Create new notification' | translate }}">
  <i class="far fa-plus fa-2x"></i>
</button>
